import type { IconData } from '@stacksjs/iconify-core'

export const functions: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m402.034 206.447l-67.528 65.278l-3.046-14.231l-.044-.2a63.45 63.45 0 0 0-59.129-49.282l-.329-.014h-67.184l18.846-87.688A31.45 31.45 0 0 1 252.549 96h47.637V64h-48l-.659.014A63.45 63.45 0 0 0 192.4 113.3L172.044 208H88v32h77.166l-32.6 151.688A31.45 31.45 0 0 1 103.637 416H56v32h48.329l.329-.014a63.45 63.45 0 0 0 59.13-49.282L197.9 240h73.369a31.45 31.45 0 0 1 28.925 24.3l7.2 33.639L193.531 408h46.042l75.711-73.187l5.07 23.693l.043.2a63.45 63.45 0 0 0 59.13 49.282L432 408v-32h-51.451a31.45 31.45 0 0 1-28.927-24.3l-9.222-43.1l105.676-102.153Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default functions
